import * as React from "react";
import { RouteNode } from "react-router5";
import { connect } from "react-redux";

import { PlaceDetail } from "./place";
import PlaceList from "./place-list/PlaceList";
import { PlaceSearchForm } from "./search";
import { SignInForm } from "./sign-in";
import { RegisterForm, RegisterSuccess } from "./register";

export class Root extends React.Component {
  renderChild(route) {
    switch (route.name) {
      case "home":
        return <PlaceSearchForm />;
      case "map":
        return <PlaceSearchForm />;
      case "place-detail":
        return <PlaceDetail />;
      case "place-list":
        return <PlaceList />;
      case "sign-in":
        return <SignInForm />;
      case "register":
        return <RegisterForm />;
      case "register-success":
        return <RegisterSuccess />;
      default:
        return null;
    }
  }

  render() {
    return [
      <div key="content" className="content">
        <RouteNode nodeName="">
          {({ route }) => this.renderChild(route)}
        </RouteNode>
      </div>,
    ];
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, null)(Root);
